package org.mkui.palette

enum class PaletteType {
    SEQUENTIAL, DIVERGING, QUALITATIVE
}